import {
  Alert,
  AlertAction,
  AlertDescription,
  AlertTitle,
  Button,
} from "@aircall/ds";
import { AiAssistPro, X } from "@aircall/react-icons";
import { useTranslation } from "react-i18next";
import { DASHBOARD_URL } from "@/constants/environment.constants";
import { useAuthenticationState } from "@/hooks/useAuthenticationState/useAuthenticationState";
import { useCall } from "@/hooks/useCall/useCall";
import { useShouldDisplayPromotionalBanner } from "@/hooks/useShouldDisplayPromotionalBanner/useShouldDisplayPromotionalBanner";
import { useAiAssistProUpsellStore } from "@/store/persistent_stores/ai_assist_pro_upsell/ai_assist_pro_upsell";

export function AiPromotionalBanner() {
  const { t } = useTranslation();
  const { authState } = useAuthenticationState();
  const userId = authState.decodedToken?.["custom:user_id"];
  const isDismissed = useAiAssistProUpsellStore((state) =>
    Boolean(userId && state.dismissedUsers[userId])
  );
  const dismiss = useAiAssistProUpsellStore((state) => state.dismiss);
  const { call } = useCall();
  const isEligible = useShouldDisplayPromotionalBanner();

  if (!userId || !isEligible || call?.type === "voicemail" || isDismissed) {
    return null;
  }

  const addonUrl = new URL("/addons/aircall_ai", DASHBOARD_URL);
  addonUrl.searchParams.set("from", window.location.pathname);

  return (
    <Alert
      variant="info"
      className="grid-cols-[24px_minmax(0,1fr)]! w-full border-blue-700 bg-[linear-gradient(90deg,rgba(5,91,195,0.2)_0%,rgba(255,255,255,0)_100%)] bg-white min-[1200px]:grid-cols-[24px_minmax(0,1fr)_auto]! [&>svg]:text-blue-700"
      data-test="ai-assist-pro-alert"
    >
      <AiAssistPro />
      <AlertTitle className="text-base font-medium leading-6 text-foreground min-[1200px]:whitespace-nowrap">
        {t("ai.banner.title")}
      </AlertTitle>
      <AlertDescription className="text-sm font-normal leading-5 text-foreground">
        {t("ai.banner.description")}
      </AlertDescription>
      <AlertAction className="col-start-2! row-start-3! row-end-4! mt-2 items-center justify-end gap-2 min-[1200px]:col-start-3! min-[1200px]:row-start-1! min-[1200px]:row-end-3! min-[1200px]:mt-0">
        <Button
          variant="default"
          size="sm"
          className="h-10 rounded-lg bg-blue-50 px-4 text-blue-700 hover:bg-blue-100"
          render={
            <a
              href={addonUrl.toString()}
              target="_blank"
              rel="noopener noreferrer"
            />
          }
        >
          {t("ai.banner.button")}
        </Button>
        <Button
          variant="ghost"
          size="icon-sm"
          className="size-8 shrink-0"
          aria-label={t("close")}
          onClick={() => dismiss(userId)}
        >
          <X className="size-4" />
        </Button>
      </AlertAction>
    </Alert>
  );
}
